import React from 'react';
import { WHY_GRP, STATS } from '../data/constants';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { scrollToSection } from '../utils/scrollTo';

const WhyGRP: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  return (
    <section id="why-grp" ref={setRef('why-grp')} className="why-section">
      <div className="why-inner">

        {/* Stats row */}
        <div className={`why-stats-row sf ${isVisible('why-grp') ? 'vis' : ''}`}>
          {STATS.map(s => (
            <div key={s.label} className="why-stat">
              <div className="why-stat-num">{s.value}</div>
              <div className="why-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Body: headline left, cards right */}
        <div className="why-body">
          <div className={`sf ${isVisible('why-grp') ? 'vis' : ''}`} style={{ transitionDelay: '0.1s' }}>
            <div className="eyebrow">Sustainable Construction</div>
            <h2 className="section-h2-white">Why Choose Us</h2>
            <p className="why-desc">
              Glass Reinforced Plastic consistently outperforms steel, concrete, and wood across durability, weight, maintenance, and lifecycle cost — the material of choice for demanding Gulf environments.
            </p>
            <button className="btn-yellow" onClick={() => scrollToSection('contact')}>Consult Now →</button>
            {/* Large side image */}
            <div style={{ marginTop: 40, borderRadius: 4, overflow: 'hidden' }}>
              <img
                src="../pots.webp"
                alt="GRP Engineering"
                style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover' }}
              />
            </div>
          </div>

          {/* Numbered reason cards */}
          <div className="why-cards-col">
            {WHY_GRP.map((item, i) => (
              <div key={item.title} className={`why-card sf ${isVisible('why-grp') ? 'vis' : ''}`} style={{ transitionDelay: `${0.1 + i * 0.08}s` }}>
                <div className="why-card-num">{String(i + 1).padStart(2, '0')}</div>
                <div className="why-card-content">
                  <h4 className="why-card-title">{item.title}</h4>
                  <p className="why-card-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default WhyGRP;
